export const LANGS = [
  { code: "es", label: "ES" },
  { code: "ca", label: "CA" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];

export const T = {
  es: {
    nav: { products: "Productos", legacy: "Experiencia", contact: "Contacto", cta: "Contacto rápido", access: "Área clientes" },
    hero: {
      overline: "Filtros de partículas · Catalizadores · Camión",
      line1: "INGENIERÍA",
      line2: "PARA EL ESCAPE.",
      line3: "HECHO PARA LO PESADO.",
      sub: "DPNox suministra filtros de partículas DPF/FAP y catalizadores para camión, respaldados por la experiencia de Diesel PaCo.",
      cta: "Ver catálogo",
      cta2: "Contactar",
      scroll: "Desliza",
    },
    marquee: "FILTROS DPF / FAP · CATALIZADORES · EURO 6 · CALIDAD OEM · HOMOLOGADO IDIADA · B2B INDUSTRIAL ·",
    catalog: {
      overline: "Catálogo",
      title: "Catálogo",
      sub: "Selecciona el producto que necesitas y solicita información sin compromiso.",
      dpf: "Filtros de partículas DPF / FAP",
      catalyst: "Catalizadores de camión",
      inquire: "Solicitar información",
      order: "Ver precios y pedir",
      ref: "Ref.",
      searchLabel: "Buscar en el catálogo",
      searchPlaceholder: "Marca, referencia, OEM, descripción…",
      oem: "OEM",
      results: "resultado(s)",
      noResults: "No hay productos que coincidan con tu búsqueda. Contáctanos y te ayudamos.",
      clear: "Borrar",
      viewDetails: "Ver ficha",
      detail: {
        tech: "Ficha técnica",
        oemTitle: "Referencias OEM compatibles",
        request: "Solicitar información",
        price: "Precio cliente",
        stock: "Stock",
        order: "Pedir ahora",
        labels: { brand: "Marca", model: "Modelo", euro: "Norma", diameter: "Diámetro", length: "Longitud", weight: "Peso", material: "Material", condition: "Estado", warranty: "Garantía", delivery: "Entrega" },
      },
    },
    legacy: {
      overline: "Respaldo",
      title: "La experiencia de Diesel PaCo, ahora DPNox",
      chapters: [
        { n: "01", t: "Herencia diésel", d: "Años de trabajo con sistemas de emisiones de vehículo pesado nos avalan. DPNox nace de la experiencia de Diesel PaCo." },
        { n: "02", t: "Calidad garantizada", d: "Extraemos todos los componentes del catalizador y colocamos elementos nuevos homologados en IDIADA." },
        { n: "03", t: "Sin un solo detalle fuera", d: "Monolitos de última generación y nuevos kits de sellado para garantizar el correcto funcionamiento." },
        { n: "04", t: "Acabado impecable", d: "Aplicamos un revestimiento térmico de alta durabilidad y enviamos con la máxima seguridad." },
      ],
    },
    contact: {
      overline: "Contacto",
      big: "HABLEMOS",
      sub: "Escríbenos con cualquier duda y nos pondremos en contacto contigo.",
      email: "Correo",
      phone: "Teléfono",
      phoneTbd: "Próximamente",
      wa: { label: "WhatsApp", prefill: "Hola DPNox, me gustaría recibir información." },
      form: {
        title: "Contacto rápido",
        name: "Nombre y apellidos",
        company: "Empresa",
        email: "Correo electrónico",
        phone: "Teléfono",
        product: "Producto de interés",
        message: "Mensaje",
        send: "Enviar solicitud",
        sending: "Enviando…",
        ok: "¡Gracias! Hemos recibido tu solicitud. Te contactaremos pronto.",
        err: "No se pudo enviar. Inténtalo de nuevo.",
        placeholder: "Cuéntanos qué necesitas…",
      },
    },
    area: {
      loginTitle: "Área de clientes",
      loginSub: "Acceso exclusivo para clientes: entra para ver precios, stock y tu histórico de pedidos.",
      user: "Usuario",
      pass: "Contraseña",
      enter: "Entrar",
      wrong: "Usuario o contraseña incorrectos.",
      noAccess: "¿Aún no tienes acceso?",
      contactUs: "Pídelo por WhatsApp",
      badge: "Demo",
      logout: "Cerrar sesión",
      history: "Histórico",
      historyTitle: "Histórico de pedidos",
      note: "Área de demostración: los datos son de ejemplo. En la versión final verás tu información real.",
      th: { id: "Pedido", date: "Fecha", items: "Artículos", total: "Total", qty: "Uds." },
      st: { in: "Disponible", low: "Últimas unidades", out: "Bajo pedido" },
      invoice: "Solicitar factura",
      invSubject: "Solicitud de factura",
      reqSubject: "Solicitud de artículo",
    },
    footer: { rights: "Todos los derechos reservados.", tagline: "Filtros y catalizadores de camión." },
  },
  ca: {
    nav: { products: "Productes", legacy: "Experiència", contact: "Contacte", cta: "Contacte ràpid", access: "Àrea clients" },
    hero: {
      overline: "Filtres de partícules · Catalitzadors · Camió",
      line1: "ENGINYERIA",
      line2: "PER A L'ESCAPAMENT.",
      line3: "FET PER AL PESANT.",
      sub: "DPNox subministra filtres de partícules DPF/FAP i catalitzadors per a camió, amb el suport de l'experiència de Diesel PaCo.",
      cta: "Veure catàleg",
      cta2: "Contactar",
      scroll: "Llisca",
    },
    marquee: "FILTRES DPF / FAP · CATALITZADORS · EURO 6 · QUALITAT OEM · HOMOLOGAT IDIADA · B2B INDUSTRIAL ·",
    catalog: {
      overline: "Catàleg",
      title: "Catàleg",
      sub: "Selecciona el producte que necessites i sol·licita informació sense compromís.",
      dpf: "Filtres de partícules DPF / FAP",
      catalyst: "Catalitzadors de camió",
      inquire: "Sol·licitar informació",
      order: "Veure preus i demanar",
      ref: "Ref.",
      searchLabel: "Cerca al catàleg",
      searchPlaceholder: "Marca, referència, OEM, descripció…",
      oem: "OEM",
      results: "resultat(s)",
      noResults: "No hi ha productes que coincideixin amb la cerca. Contacta'ns i t'ajudem.",
      clear: "Esborrar",
      viewDetails: "Veure fitxa",
      detail: {
        tech: "Fitxa tècnica",
        oemTitle: "Referències OEM compatibles",
        request: "Sol·licitar informació",
        price: "Preu client",
        stock: "Estoc",
        order: "Demanar ara",
        labels: { brand: "Marca", model: "Model", euro: "Norma", diameter: "Diàmetre", length: "Longitud", weight: "Pes", material: "Material", condition: "Estat", warranty: "Garantia", delivery: "Lliurament" },
      },
    },
    legacy: {
      overline: "Suport",
      title: "L'experiència de Diesel PaCo, ara DPNox",
      chapters: [
        { n: "01", t: "Herència dièsel", d: "Anys de treball amb sistemes d'emissions de vehicle pesant ens avalen. DPNox neix de l'experiència de Diesel PaCo." },
        { n: "02", t: "Qualitat garantida", d: "Extraiem tots els components del catalitzador i col·loquem elements nous homologats a IDIADA." },
        { n: "03", t: "Sense cap detall fora", d: "Monòlits d'última generació i nous kits de segellat per garantir el correcte funcionament." },
        { n: "04", t: "Acabat impecable", d: "Apliquem un revestiment tèrmic d'alta durabilitat i enviem amb la màxima seguretat." },
      ],
    },
    contact: {
      overline: "Contacte",
      big: "PARLEM",
      sub: "Escriu-nos amb qualsevol dubte i ens posarem en contacte amb tu.",
      email: "Correu",
      phone: "Telèfon",
      phoneTbd: "Properament",
      wa: { label: "WhatsApp", prefill: "Hola DPNox, m'agradaria rebre informació." },
      form: {
        title: "Contacte ràpid",
        name: "Nom i cognoms",
        company: "Empresa",
        email: "Correu electrònic",
        phone: "Telèfon",
        product: "Producte d'interès",
        message: "Missatge",
        send: "Enviar sol·licitud",
        sending: "Enviant…",
        ok: "Gràcies! Hem rebut la teva sol·licitud. Et contactarem aviat.",
        err: "No s'ha pogut enviar. Torna-ho a provar.",
        placeholder: "Explica'ns què necessites…",
      },
    },
    area: {
      loginTitle: "Àrea de clients",
      loginSub: "Accés exclusiu per a clients: entra per veure preus, estoc i el teu històric de comandes.",
      user: "Usuari",
      pass: "Contrasenya",
      enter: "Entrar",
      wrong: "Usuari o contrasenya incorrectes.",
      noAccess: "Encara no tens accés?",
      contactUs: "Demana'l per WhatsApp",
      badge: "Demo",
      logout: "Tancar sessió",
      history: "Històric",
      historyTitle: "Històric de comandes",
      note: "Àrea de demostració: les dades són d'exemple. A la versió final hi veuràs la teva informació real.",
      th: { id: "Comanda", date: "Data", items: "Articles", total: "Total", qty: "Uts." },
      st: { in: "Disponible", low: "Últimes unitats", out: "Sota comanda" },
      invoice: "Sol·licitar factura",
      invSubject: "Sol·licitud de factura",
      reqSubject: "Sol·licitud d'article",
    },
    footer: { rights: "Tots els drets reservats.", tagline: "Filtres i catalitzadors de camió." },
  },
  en: {
    nav: { products: "Products", legacy: "Experience", contact: "Contact", cta: "Quick contact", access: "Client area" },
    hero: {
      overline: "Particulate filters · Catalysts · Truck",
      line1: "ENGINEERED",
      line2: "FOR EXHAUST.",
      line3: "BUILT FOR HEAVY DUTY.",
      sub: "DPNox supplies DPF/FAP particulate filters and truck catalysts, backed by the experience of Diesel PaCo.",
      cta: "View catalog",
      cta2: "Contact",
      scroll: "Scroll",
    },
    marquee: "DPF / FAP FILTERS · CATALYSTS · EURO 6 · OEM QUALITY · IDIADA CERTIFIED · B2B INDUSTRIAL ·",
    catalog: {
      overline: "Catalog",
      title: "Catalog",
      sub: "Pick the product you need and request information with no commitment.",
      dpf: "DPF / FAP particulate filters",
      catalyst: "Truck catalysts",
      inquire: "Request info",
      order: "See prices & order",
      ref: "Ref.",
      searchLabel: "Search the catalog",
      searchPlaceholder: "Brand, reference, OEM, description…",
      oem: "OEM",
      results: "result(s)",
      noResults: "No products match your search. Contact us and we'll help you.",
      clear: "Clear",
      viewDetails: "View details",
      detail: {
        tech: "Technical sheet",
        oemTitle: "Compatible OEM references",
        request: "Request info",
        price: "Client price",
        stock: "Stock",
        order: "Order now",
        labels: { brand: "Brand", model: "Model", euro: "Standard", diameter: "Diameter", length: "Length", weight: "Weight", material: "Material", condition: "Condition", warranty: "Warranty", delivery: "Delivery" },
      },
    },
    legacy: {
      overline: "Backed by",
      title: "The Diesel PaCo experience, now DPNox",
      chapters: [
        { n: "01", t: "Diesel heritage", d: "Years working with heavy-vehicle emission systems back us up. DPNox is born from the experience of Diesel PaCo." },
        { n: "02", t: "Guaranteed quality", d: "We extract every catalyst component and fit new elements certified at IDIADA." },
        { n: "03", t: "No detail left out", d: "Latest-generation monoliths and new sealing kits to guarantee correct operation." },
        { n: "04", t: "Flawless finish", d: "We apply a high-durability thermal coating and ship with maximum safety." },
      ],
    },
    contact: {
      overline: "Contact",
      big: "LET'S TALK",
      sub: "Write to us with any question and we'll get back to you.",
      email: "Email",
      phone: "Phone",
      phoneTbd: "Coming soon",
      wa: { label: "WhatsApp", prefill: "Hello DPNox, I would like to receive information." },
      form: {
        title: "Quick contact",
        name: "Full name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        product: "Product of interest",
        message: "Message",
        send: "Send request",
        sending: "Sending…",
        ok: "Thanks! We received your request. We'll contact you soon.",
        err: "Could not send. Please try again.",
        placeholder: "Tell us what you need…",
      },
    },
    area: {
      loginTitle: "Client area",
      loginSub: "Exclusive client access: sign in to see prices, stock and your order history.",
      user: "Username",
      pass: "Password",
      enter: "Sign in",
      wrong: "Incorrect username or password.",
      noAccess: "No access yet?",
      contactUs: "Request it on WhatsApp",
      badge: "Demo",
      logout: "Log out",
      history: "History",
      historyTitle: "Order history",
      note: "Demo area: the data shown is sample data. The final version will show your real information.",
      th: { id: "Order", date: "Date", items: "Items", total: "Total", qty: "Qty" },
      st: { in: "In stock", low: "Last units", out: "On order" },
      invoice: "Request invoice",
      invSubject: "Invoice request",
      reqSubject: "Item request",
    },
    footer: { rights: "All rights reserved.", tagline: "Truck filters and catalysts." },
  },
  de: {
    nav: { products: "Produkte", legacy: "Erfahrung", contact: "Kontakt", cta: "Schnellkontakt", access: "Kundenbereich" },
    hero: {
      overline: "Partikelfilter · Katalysatoren · Lkw",
      line1: "TECHNIK",
      line2: "FÜRS ABGASSYSTEM.",
      line3: "GEBAUT FÜR SCHWERLAST.",
      sub: "DPNox liefert DPF/FAP-Partikelfilter und Lkw-Katalysatoren, gestützt auf die Erfahrung von Diesel PaCo.",
      cta: "Katalog ansehen",
      cta2: "Kontakt",
      scroll: "Scrollen",
    },
    marquee: "DPF / FAP FILTER · KATALYSATOREN · EURO 6 · OEM-QUALITÄT · IDIADA-ZERTIFIZIERT · B2B INDUSTRIE ·",
    catalog: {
      overline: "Katalog",
      title: "Katalog",
      sub: "Wählen Sie das gewünschte Produkt und fordern Sie unverbindlich Informationen an.",
      dpf: "DPF / FAP Partikelfilter",
      catalyst: "Lkw-Katalysatoren",
      inquire: "Informationen anfordern",
      order: "Preise & bestellen",
      ref: "Ref.",
      searchLabel: "Katalog durchsuchen",
      searchPlaceholder: "Marke, Referenz, OEM, Beschreibung…",
      oem: "OEM",
      results: "Ergebnis(se)",
      noResults: "Keine passenden Produkte gefunden. Kontaktieren Sie uns — wir helfen gerne.",
      clear: "Löschen",
      viewDetails: "Details ansehen",
      detail: {
        tech: "Technisches Datenblatt",
        oemTitle: "Kompatible OEM-Referenzen",
        request: "Informationen anfordern",
        price: "Kundenpreis",
        stock: "Bestand",
        order: "Jetzt bestellen",
        labels: { brand: "Marke", model: "Modell", euro: "Norm", diameter: "Durchmesser", length: "Länge", weight: "Gewicht", material: "Material", condition: "Zustand", warranty: "Garantie", delivery: "Lieferung" },
      },
    },
    legacy: {
      overline: "Erfahrung",
      title: "Die Diesel-PaCo-Erfahrung, jetzt DPNox",
      chapters: [
        { n: "01", t: "Diesel-Erbe", d: "Jahrelange Arbeit mit Abgassystemen schwerer Fahrzeuge spricht für uns. DPNox entsteht aus der Erfahrung von Diesel PaCo." },
        { n: "02", t: "Garantierte Qualität", d: "Wir entnehmen alle Komponenten des Katalysators und setzen neue, bei IDIADA zertifizierte Elemente ein." },
        { n: "03", t: "Kein Detail vergessen", d: "Monolithe der neuesten Generation und neue Dichtungskits garantieren den einwandfreien Betrieb." },
        { n: "04", t: "Makelloses Finish", d: "Wir tragen eine hochbeständige Thermobeschichtung auf und versenden mit maximaler Sicherheit." },
      ],
    },
    contact: {
      overline: "Kontakt",
      big: "SPRECHEN WIR",
      sub: "Schreiben Sie uns bei Fragen — wir melden uns bei Ihnen.",
      email: "E-Mail",
      phone: "Telefon",
      phoneTbd: "Demnächst",
      wa: { label: "WhatsApp", prefill: "Hallo DPNox, ich hätte gerne Informationen." },
      form: {
        title: "Schnellkontakt",
        name: "Vor- und Nachname",
        company: "Firma",
        email: "E-Mail",
        phone: "Telefon",
        product: "Gewünschtes Produkt",
        message: "Nachricht",
        send: "Anfrage senden",
        sending: "Wird gesendet…",
        ok: "Danke! Wir haben Ihre Anfrage erhalten und melden uns bald.",
        err: "Senden fehlgeschlagen. Bitte erneut versuchen.",
        placeholder: "Womit können wir helfen…",
      },
    },
    area: {
      loginTitle: "Kundenbereich",
      loginSub: "Exklusiver Kundenzugang: Anmelden, um Preise, Bestand und Ihre Bestellhistorie zu sehen.",
      user: "Benutzer",
      pass: "Passwort",
      enter: "Anmelden",
      wrong: "Falscher Benutzername oder falsches Passwort.",
      noAccess: "Noch kein Zugang?",
      contactUs: "Per WhatsApp anfragen",
      badge: "Demo",
      logout: "Abmelden",
      history: "Verlauf",
      historyTitle: "Bestellhistorie",
      note: "Demo-Bereich: Alle Daten sind Beispieldaten. In der finalen Version sehen Sie Ihre echten Informationen.",
      th: { id: "Bestellung", date: "Datum", items: "Artikel", total: "Gesamt", qty: "Stk." },
      st: { in: "Verfügbar", low: "Letzte Einheiten", out: "Auf Bestellung" },
      invoice: "Rechnung anfordern",
      invSubject: "Rechnungsanforderung",
      reqSubject: "Artikelanfrage",
    },
    footer: { rights: "Alle Rechte vorbehalten.", tagline: "Lkw-Filter und Katalysatoren." },
  },
};
